export interface IThemeColors {
  white: string;
  primary: string;
  text: string;
  blockStroke: string;
  lightGrey: string;
  darkGrey: string;
  light: string;
  mediumDarkGrey: string;
  disabledText: string;
  grey: string;
  red: string;
  primaryWhite: string;
  chablis: string;
  solitude: string;
  mako: string;
}

export const colorPalette: IThemeColors = {
  white: '#ffffff',
  primary: '#1890ff',
  primaryWhite: '#66BAFF',
  blockStroke: 'rgba(192, 212, 227, 0.4)',
  text: '#3C3F4A',
  lightGrey: '#ECF2F7',
  light: '#ECF2F7',
  darkGrey: '#68717B',
  mediumDarkGrey: '#AFB7BF',
  disabledText: '#94979B',
  grey: '#C0D4E3',
  red: '#FF6960',
  chablis: '#FFF0EF',
  solitude: '#EBF6FF',
  mako: '#3E444A',
};

